export const LOCAL_STORAGE_LAYOUT_CONFIG_KEY = 'layoutConfig'
export const LAYOUT_BREAKPOINTS = {
  lg: 1200,
  md: 996,
  sm: 768,
  xs: 480,
  xxs: 0
}
export const LAYOUT_COLS = { lg: 30, md: 6, sm: 2, xs: 1, xxs: 1 }
export const LAYOUT_CONFIG = {
  version: 'v2',
  layouts: {
    spot: {
      lg: [
        { i: 'MarketChart', x: 0, y: 0, w: 18, h: 15, minW: 13, minH: 8 },
        { i: 'OrderBook', x: 18, y: 0, w: 6, h: 15, minW: 6, minH: 8 },
        { i: 'OrderForm', x: 24, y: 0, w: 6, h: 15, minW: 6 },
        { i: 'RecentTrades', x: 24, y: 11, w: 6, h: 10, minW: 5 },
        { i: 'Orders', x: 0, y: 11, w: 24, h: 10, minW: 5 }
      ]
    },
    futures: {
      lg: [
        { i: 'MarketChart', x: 0, y: 0, w: 18, h: 15, minW: 13, minH: 8 },
        { i: 'OrderBook', x: 18, y: 0, w: 6, h: 15, minW: 6, minH: 8 },
        { i: 'OrderForm', x: 18, y: 11, w: 12, h: 15, minW: 12 },
        { i: 'RecentTrades', x: 24, y: 0, w: 6, h: 15, minW: 5 },
        { i: 'Orders', x: 0, y: 11, w: 18, h: 10, minW: 13 }
      ]
    }
  }
}
